<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingMyCharges"
  >

    <div class="align-items-baseline display-flex-row m-filters-and-actions">
      <form
        autocomplete="off"
        class="align-items-baseline m-form-row m-simple-filter"
        name="simple-filters-form"
        @submit.prevent="searchSimpleFilter"
      >
        <AtomSelectPrimary
          v-model.number="simpleFilter.typeSales"
          :disabled="pagination.showLoadingState"
          :elements="$filters.parameters.typesOfSales"
          keyField="id"
          name="saleType"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />
        <AtomSelectPrimary
          v-model.number="simpleFilter.estado"
          :disabled="simpleFilter.typeSales || pagination.showLoadingState"
          :elements="[...this.$filters.parameters.salesStates].filter(s => s.id !== 9)"
          keyField="id"
          name="estado"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomSelectPrimary
          v-model.number="simpleFilter.periodo"
          :disabled="pagination.showLoadingState"
          :elements="$filters.parameters.periods"
          keyField="id"
          name="periodo"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomInputPrimary
          v-model="simpleFilter.buscar"
          :disabled="pagination.showLoadingState"
          name="email"
          placeholder="alumno@email.com"
          type="email"
          wrapperClass="a-input-wrapper-row"
          @input="searchSimpleFilter"
        />

        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reset"
          :disabled="pagination.showLoadingState"
          @reloadListing="reloadListing"
        />
      </form>

      <div class="m-dropdown-primary">
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.filter"
          :disabled="pagination.showLoadingState"
          @switchDropDown="$dropDown.switchDropDown"
        />
        <MoleculeEditionBillingMySalesDropDownFilters
          :filter-seted="filter"
          @reloadListing="reloadListing"
          @searchAdvancedFilter="searchAdvancedFilter"
        />
      </div>

      <div class="display-flex-row margin-left-auto">
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.payments"
          @goToInvoicesHistory="goToInvoicesHistory"
        />
        <form
          autocomplete="off"
          class="m-form-row"
          name="download-csv-form"
          @submit.prevent="readVentasExportar"
        >
          <AtomButtonPrimary
            :button-primary="buttonPrimary"
            :disabled="pagination.showLoadingState || !ventas.length"
          />
        </form>
      </div>
    </div>

    <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="ventas.length">
          <th
            class="text-align-right"
            width="15%"
          >
            {{ $t('mEditionBillingMySales.table.thTotal') }}
          </th>
          <th
            class="text-align-center"
            width="13%"
          >
             {{ $t('mEditionBillingMySales.table.thDate') }}
          </th>
          <th
            class="text-align-center"
            width="10%"
          >
             {{ $t('mEditionBillingMySales.table.thDiscount') }}
          </th>
          <th
            class="text-align-center"
            width="13%"
          >
             {{ $t('mEditionBillingMySales.table.thMethod') }}
          </th>
          <th
            class="text-align-left"
            width="14%"
          >
             {{ $t('mEditionBillingMySales.table.thConcept') }}
          </th>
          <th
            class="text-align-left"
            width="16%"
          >
             {{ $t('mEditionBillingMySales.table.thClient') }}
          </th>
          <th
            class="text-align-center"
            width="11%"
          >
             {{ $t('mEditionBillingMySales.table.thToPay') }}
          </th>
          <th
            class="text-align-center"
            width="8%"
          >
             {{ $t('mEditionBillingMySales.table.thRecord') }}
          </th>
        </tr>
        <tr
          v-for="(venta, index) in ventas"
          :key="index"
          class="row-data"
        >
          <td class="text-align-right text-white-space-nowrap">
            <a
              v-if="venta.total || venta.precio"
              class="sale-state"
              :href="`${$t('mEditionMenu.billing.mySales.subject')}/${venta.id_venta}/${$t('mEditionMenu.billing.mySales.children.record.subedition')}`"
              @click.prevent="gotToSaleRecord(venta)"
            >
              <span>{{ venta.divisa }} {{ venta.total.toFixed(2)/*getTotalVenta(venta.total, venta.precio, venta.trial_precio, venta.pago_cuotas).toFixed(2)*/ }}</span>
              <span class="text-color-black-35"> {{ venta.divisa_iso_code }}</span><br>
              <small :class="$filters.getSaleStateValue(venta.venta_estado, 'class')">
                {{ $filters.getSaleStateValue(venta.venta_estado, 'name') }}
              </small>
            </a>
            <a
             v-else
              class="sale-state"
              href="#"
              @click.prevent="gotToSaleRecord(venta)"
            >
              <span>{{ $t('mEditionBillingMySales.free') }}</span><br>
              <small :class="$filters.getSaleStateValue(venta.venta_estado, 'class')">
                {{ $filters.getSaleStateValue(venta.venta_estado, 'name') }}
              </small>
            </a>
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            {{ $moment.parseZone(venta.fecha_venta).format('D MMM YYYY') }}
          </td>
          <td class="ellipsis text-align-center">
            <span
              v-if="venta.cupon_codigo"
              :key="`${index}-${venta.cupon_codigo}`"
            >
              {{ venta.cupon_codigo }}
            </span>
            <span
              v-else
              :key="`${index}-nodiscount`"
            >
              -
            </span>
          </td>
          <td class="text-align-center">
            <span v-if="venta.medio_pago">
              {{ venta.medio_pago }}
            </span>
            <span v-else>
              -
            </span>
          </td>
          <td class="break-word text-align-left">
            {{ venta.concepto }}
          </td>
          <td class="break-word text-align-left">
            <span class="display-flex-column">
              <span>{{ venta.nombre_cliente }}</span>
              <small class="ellipsis font-weight-regular text-color-black-35">
                {{ venta.email_cliente }}
              </small>
            </span>
          </td>
          <td class="text-align-center">
            {{
              venta.total || venta.precio
                ? $utils.getPaymentFrequency(venta.pago_cuotas, venta.pago_frecuencia, venta.pago_intervalo)
                : '-'
            }}
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.record"
              :element="venta"
              @gotToSaleRecord="gotToSaleRecord"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import { validateEmail } from '@/plugins/validation/validators'

export default {
  name: 'MoleculeEditionBillingMySales',

  components: {
    MoleculeEditionBillingMySalesDropDownFilters: () => import('@/components/molecules/MoleculeEditionBillingMySalesDropDownFilters'),
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      buttonIconRounded: {
        record: {
          class: 'a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'far fa-file-alt',
          method: 'gotToSaleRecord',
          tooltip: 'Ver Venta',
          type: 'button'
        }
      },

      buttonPrimary: {
        action: this.$t('mEditionBillingMySales.buttonPrimary'),
        behavior: 'download',
        class: 'a-button-primary a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        filter: {
          class: 'a-button-secondary a-button-billing-secondary',
          component: 'MoleculeEditionBillingMySalesDropDownFilters',
          icon: 'fas fa-filter',
          method: 'switchDropDown',
          text: this.$t('mEditionBillingMySales.buttonSecondary.filterText'),
          type: 'button'
        },

        payments: {
          class: 'a-button-secondary a-button-billing-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-file-alt',
          method: 'goToInvoicesHistory',
          text: '',
          tooltip: 'Ver Comprobantes', // this.$t('mEditionBillingMySales.tooltip.restart'),
          type: 'button'
        },

        reset: {
          class: 'a-button-secondary a-button-billing-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'reloadListing',
          text: '',
          tooltip: this.$t('mEditionBillingMySales.tooltip.restart'),
          type: 'button'
        }
      },

      filter: {
        buscar: '',
        cupon: '',
        divisa: [],
        estado: [],
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pagina: 1,
        pais: '',
        pasarela_pago: [],
        producto: [],
        type_sales: ''
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      showLoadingState: true,

      simpleFilter: {
        buscar: '',
        estado: '',
        periodo: 0,
        typeSales: 0
      },

      ventas: []
    }
  },

  created () {
    this.searchSimpleFilter()
  },

  methods: {
    getTotalVenta (total, monto, trial, cuotas) {
      if (!total && monto) {
        total = monto
      }
      return !cuotas
        ? total
        : (cuotas * monto) + trial
    },

    goToInvoicesHistory () {
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.mySales.subject')}/${this.$t('mEditionMenu.billing.mySales.children.invoicesHistory.subedition')}`)
    },

    gotToSaleRecord (venta) {
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.mySales.subject')}/${venta.id_venta}/${this.$t('mEditionMenu.billing.mySales.children.record.subedition')}`)
    },

    readVentas () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('ventas', 'readVentas', {}, [this.$store.getters.getAcademyData.id], this.filter)
          .then(response => {
            this.ventas = []
            this.ventas = response.data.ventas
            this.pagination.currentQuantity = this.ventas.length
            this.pagination.totalPages = response.data.pages
            this.pagination.totalQuantity = response.data.total
            this.pagination.showLoadingState = false
            this.showLoadingState = false
          })
          .catch(error => {
            console.log(error)
            this.ventas = []
            this.pagination.currentQuantity = 0
            this.pagination.totalPages = 0
            this.pagination.totalQuantity = 0
            this.pagination.showLoadingState = false
            this.showLoadingState = false
          })
      }
    },

    readVentasExportar () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.read('ventas', 'readVentasExportar', {}, [this.$store.getters.getAcademyData.id], this.filter)
          .then(response => {
            this.$files.downloadCsv(response.data, `${this.$t('mEditionBillingMySales.files.sales')}-${this.$moment().format('YYYYMMDD')}`)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionBillingMySales', 'readVentasExportar', 'success')
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionBillingMySales', 'readVentasExportar', 'error', 'a-alert-danger')
          })
      }
    },

    reloadListing () {
      this.resetSimpleFilter()
      this.resetAdvancedFilter()
      this.setPaginationCurrentPage(1)
    },

    resetAdvancedFilter () {
      this.filter = {
        buscar: '',
        cupon: '',
        divisa: [],
        estado: [],
        type_sales: 0,
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pagina: 1,
        pais: '',
        pasarela_pago: [],
        producto: []
      }
    },

    resetSimpleFilter () {
      this.simpleFilter = {
        buscar: '',
        estado: '',
        typeSales: this.filter.type_sales || 0,
        periodo: 0
      }
    },

    searchAdvancedFilter (advancedFilter) {
      this.filter = Object.assign({}, advancedFilter)
      this.resetSimpleFilter()
      this.setPaginationCurrentPage(1)
    },

    searchSimpleFilter () {
      if (validateEmail(this.simpleFilter.buscar) ||
        this.simpleFilter.buscar === '') {
        this.resetAdvancedFilter()
        this.filter.buscar = this.simpleFilter.buscar

        if (this.simpleFilter.typeSales === '') {
          this.simpleFilter.typeSales = 0
        }

        if (this.simpleFilter.estado !== '') {
          this.filter.estado[0] = this.simpleFilter.estado
        }

        if (this.simpleFilter.periodo === '') {
          this.simpleFilter.periodo = 0
        }

        this.filter.fecha_desde = this.$filters.parameters.periods[this.simpleFilter.periodo].dateFrom
        this.filter.fecha_hasta = this.$filters.parameters.periods[this.simpleFilter.periodo].dateTo
        this.filter.type_sales = this.simpleFilter.typeSales
        this.setPaginationCurrentPage(1)
      }
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readVentas()
    }
  }
}
</script>
